module.exports = __webpack_public_path__ + "img/border_two_line.5280b0e1.svg";